import React from "react";
import styles from "./Footer.module.css";
import classNames from "classnames";
import GlobalMessages from "../ResponseMessages/GlobalMessages";
import BarcodeInputAutomatic from "../BarcodeInput/BarcodeInputAutomatic";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";
import { useSelector } from "react-redux";
import { currentBoxSelector } from "../../../lib/store/reducers/conveyorBoxReviewReducer";

const Footer = () => {
  const { onFetchConveyorBoxHandler } = useConveyorBoxHandlers();
  const { orderNumber } = useSelector(currentBoxSelector);
  const classes = classNames(["control-app__footer", styles["footer"]]);
  return (
    <footer className={classes}>
      {orderNumber < 1 && <BarcodeInputAutomatic onBarcodeScan={onFetchConveyorBoxHandler} />}
      <GlobalMessages />
    </footer>
  );
};

export default Footer;
